import {
    selectDoc,
    event,
    selectArr,
    toggleClass,
    observeAdd,
    styles,
    isVisible,
    hasClass,
    ajax,
    observeRemove
} from "../utils/utils";
import {PCP} from "./component.pcp";
import Glide from "../lib/glide.min";
import {initFCollectionProductCard} from "./component.home";

const props = {}

const featureCardStackGlide = () => {
    var glide = new Glide('.fm__glide', {
        type: 'carousel',
        perView: 4,
        focusAt: 0,
        bound: true,
        direction: 'rtl',
        dragThreshold: 100,
        swipeThreshold: 100,
        breakpoints: {
            768: {
                dragThreshold: 500
            }
        }
    })

    glide.on(['mount.after', 'run.after', 'run.offset'], (evt) => {
        const cards = selectArr('.fm__glide .glide__slide');
        props.active = selectDoc('.fm__glide .glide__slide--active');
        const activeIndex = cards.indexOf(props.active);
        let prev = [];
        for (let i = 0; i < cards.length; i++) {
            var pointer = (i + (activeIndex)) % cards.length;
            prev.push(cards[pointer])
        }
        for (let i = 0; i < prev.length; i++) {
            prev[i].style.transform = `scale(calc(1 - (.${i} * (3/4))))`;
            if (window.matchMedia("(max-width: 768px)").matches) {
                prev[i].style.top = `calc(-${i} * 7%)`;
            } else {
                prev[i].style.right = `calc(-${i} * 50px)`;
            }
        }
        props.active.style.transform = `scale(1)`;
        if (window.matchMedia("(max-width: 768px)").matches) {
            props.active.style.top = `0px`;
        } else {
            props.active.style.right = `0px`;
        }
    })

    glide.on('move.after', (evt) => {
        const cards = selectArr('.fm__glide .glide__slide');
        cards.forEach(item => {
            item.classList.remove('hide');
        })
    })

    glide.on('run.start', (evt) => {
        props.active = selectDoc('.fm__glide .glide__slide--active');
        props.active.style.right = `0px`;
    })

    glide.on('run.before', (evt) => {
        props.active.classList.add('hide');
    })

    glide.mount();
}

const threeUpGlide = () => {
    var glide = new Glide('.tru__glide', {
        startAt: 1,
        perView: 1,
        gap: 30,
        peek: {
            before: 0,
            after: 50
        }
    })

    glide.mount();

    function glideCheck(msq) {
        if (msq.matches) { // If media query matches
            glide.mount();
        } else {
            glide.destroy();
        }
    }

    var msq = window.matchMedia("(max-width: 768px)")
    glideCheck(msq) // Call listener function at run time
    msq.addListener(glideCheck) // Attach listener function on state changes
}

const paginate = () => {
    const btns = document.querySelectorAll('.load-more');
    btns.forEach((btn) => {
        ['click', 'keypress'].forEach((event) => {
            btn.addEventListener(event, (e) => {
                if (e.which === 13 || e.type === 'click') {
                    const collectionEl = btn.closest('.collection-list');
                    const tiles = selectArr('.tile', collectionEl);

                    tiles.forEach((tile) => (tile.dataset.loadCount === btn.dataset.btnCount) ? tile.classList.remove('hide') : '')
                    btn.dataset.btnCount++;
                    btn.disabled = (btn.dataset.btnCount > tiles[tiles.length - 1].dataset.loadCount) ? true : false;

                    /*const rect = btn.getBoundingClientRect();
                    if (window.matchMedia("(max-width: 768px)").matches) {
                        window.scrollTo({
                            top: (rect.y - 100) - (tiles[4].offsetHeight * 3),
                            left: 0,
                            behavior: 'smooth'
                        });
                    } else {
                        window.scrollTo({
                            top: (rect.y - 100) - tiles[4].offsetHeight,
                            left: 0,
                            behavior: 'smooth'
                        });
                    }*/
                }

            }, false);
        })
    })
}

const initializer = () => {
    if (selectArr('.fm')[0]) {
        featureCardStackGlide();
        initFCollectionProductCard(selectArr(`.fm__glide .product-card`));
    }
    if (selectArr('.tru')[0]) {
        threeUpGlide();
    }
    if (selectArr('.cl')[0]) {
        paginate();
    }
}

export const PCPLanding = {
    init: () => initializer()
}
